import * as types from '../types';

export const cleanupLoginState = () => {
    return {
        type: types.LOGIN_CLEANUP
    };
};
